import './anchorMobileButton.css'

export default function AnchorMobileButton({text, href}) {

    return (
        <a className="anchor-mobile-button" href={href}>
                {text}
        </a>
    );
}